module.exports = __webpack_public_path__ + "img/Google_Play.50053402.png";